module.exports = __webpack_public_path__ + "static/img/IMG_20150307_164003.0978321a.jpg";